import { render, staticRenderFns } from "./taxonomy-editor.vue?vue&type=template&id=60cb47fa&"
import script from "./taxonomy-editor.vue?vue&type=script&lang=js&"
export * from "./taxonomy-editor.vue?vue&type=script&lang=js&"
import style0 from "./taxonomy-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports